import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../assets/the+logo.png';

const NavBar = ({ theme, toggleTheme }) => {
  
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <div
      className={`font-Poppins sticky top-0 font-bold z-50 transition-colors duration-300 ${
        isSticky
          ? 'bg-white text-black dark:bg-slate-900 dark:text-white'
          : 'bg-transparent text-orange-500 dark:text-orange-400'
      }`}
    >
      <div className="container mx-auto flex items-center justify-between py-4 px-6">
        <div className="text-2xl font-bold">
          <img loading="lazy" src={logo} alt="logo" className="h-8 w-100" />
        </div>

        {/* Hamburger Menu Button */}
        <button
          onClick={toggleMenu}
          className={`text-3xl lg:hidden focus:outline-none z-50 ${
            isMenuOpen ? 'text-white' : 'text-black'
          }`}
        >
          {isMenuOpen ? '✖' : '☰'}
        </button>

        {/* Fullscreen Menu */}
        <div
          className={`fixed inset-0 bg-black transition-transform duration-700 ease-in-out transform ${
            isMenuOpen ? 'translate-y-0' : '-translate-y-full'
          } lg:hidden flex flex-col items-center justify-center text-white`}
        >
          <NavLink
            to="/home"
            className={({ isActive }) =>
              `text-2xl py-4 ${
                isActive ? 'text-orange-500' : 'text-white'
              } hover:text-orange-500`
            }
            onClick={closeMenu}
          >
            Home
          </NavLink>
          <NavLink
            to="/about"
            className={({ isActive }) =>
              `text-2xl py-4 ${
                isActive ? 'text-orange-500' : 'text-white'
              } hover:text-orange-500`
            }
            onClick={closeMenu}
          >
            About
          </NavLink>
          {/* <NavLink
            to="/transform"
            className={({ isActive }) =>
              `text-2xl py-4 ${
                isActive ? 'text-blue-500' : 'text-white'
              } hover:text-blue-500`
            }
            onClick={closeMenu}
          >
            Transform
          </NavLink> */}
          <NavLink
            to="/portfolio"
            className={({ isActive }) =>
              `text-2xl py-4 ${
                isActive ? 'text-orange-500' : 'text-white'
              } hover:text-orange-500`
            }
            onClick={closeMenu}
          >
            Portfolio
          </NavLink>
          <NavLink
            to="/services"
            className={({ isActive }) =>
              `text-2xl py-4 ${
                isActive ? 'text-orange-500' : 'text-white'
              } hover:text-orange-500`
            }
            onClick={closeMenu}
          >
            Services
          </NavLink>
          <NavLink
            to="/testimonials"
            className={({ isActive }) =>
              `text-2xl py-4 ${
                isActive ? 'text-orange-500' : 'text-white'
              } hover:text-orange-500`
            }
            onClick={closeMenu}
          >
            Testimonials
          </NavLink>
          <NavLink
            to="/contact"
            className={({ isActive }) =>
              `text-2xl py-4 ${
                isActive ? 'text-orange-500' : 'text-white'
              } hover:text-orange-500`
            }
            onClick={closeMenu}
          >
            Contact
          </NavLink>
          <button
            type="button"
            onClick={() => {
              toggleTheme();
              closeMenu();
            }}
            className="mt-8 rounded-full border border-orange-500 bg-orange-500 px-6 py-3 text-sm font-semibold text-white transition hover:bg-orange-600"
          >
            {theme === 'dark' ? 'Switch to Light' : 'Switch to Dark'}
          </button>
        </div>

        {/* Navigation Links for Large Screens */}
        <nav className="hidden lg:flex lg:items-center lg:space-x-6">
          <NavLink
            to="/home"
            className={({ isActive }) =>
              `hover:underline decoration-2 decoration-black underline-offset-4 ${
                isActive ? 'underline' : ''
              }`
            }
          >
            Home
          </NavLink>
          <NavLink
            to="/about"
            className={({ isActive }) =>
              `hover:underline decoration-2 decoration-black underline-offset-4 ${
                isActive ? 'underline' : ''
              }`
            }
          >
            About
          </NavLink>
          {/* <NavLink
            to="/transform"
            className={({ isActive }) =>
              `hover:underline decoration-2 decoration-black underline-offset-4 ${
                isActive ? 'underline' : ''
              }`
            }
          >
            Transform
          </NavLink> */}
          <NavLink
            to="/portfolio"
            className={({ isActive }) =>
              `hover:underline decoration-2 decoration-black underline-offset-4 ${
                isActive ? 'underline' : ''
              }`
            }
          >
            Portfolio
          </NavLink>
          <NavLink
            to="/services"
            className={({ isActive }) =>
              `hover:underline decoration-2 decoration-black underline-offset-4 ${
                isActive ? 'underline' : ''
              }`
            }
          >
            Services
          </NavLink>
          <NavLink
            to="/testimonials"
            className={({ isActive }) =>
              `hover:underline decoration-2 decoration-black underline-offset-4 ${
                isActive ? 'underline' : ''
              }`
            }
          >
            Testimonials
          </NavLink>
          <NavLink
            to="/contact"
            className={({ isActive }) =>
              `hover:underline decoration-2 decoration-black underline-offset-4 ${
                isActive ? 'underline' : ''
              }`
            }
          >
            Contact
          </NavLink>
          <button
            type="button"
            onClick={toggleTheme}
            className="hidden lg:inline-flex items-center gap-2 rounded-full border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-slate-900 transition hover:bg-orange-500 hover:text-white dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100 dark:hover:bg-orange-500"
          >
            {theme === 'dark' ? '☀️ Light' : '🌙 Dark'}
          </button>
        </nav>
      </div>
    </div>
  );
};

export default NavBar;
